import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { Info24Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  dialogSurface: {
    maxWidth: '320px',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 16px',
  },
  icon: {
    color: tokens.colorBrandForeground1,
    width: '40px',
    height: '40px',
    marginBottom: '2px',
  },
  message: {
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '24px',
    color: tokens.colorNeutralForeground1,
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '20px',
    color: tokens.colorNeutralForeground3,
    marginTop: '0px',
  },
});

/**
 * Session Expired Modal Component
 * Displays when user session expires, requires user to sign in again
 * This modal cannot be closed - user must complete login
 */
const SessionExpiredModal = ({ open, onLogout, isLoading = false }) => {
  const classes = useStyles();

  return (
    <Dialog 
      open={open} 
      modalType="alert"
      onOpenChange={(e, data) => {
        // Prevent user from closing via ESC or outside click
        e.preventDefault();
      }}
    >
      <DialogSurface className={classes.dialogSurface}>
        <DialogBody>
          <DialogTitle>Session Expired</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Info24Regular className={classes.icon} />
            <div className={classes.message}>
              Your session has expired
            </div>
            <div className={classes.subtitle}>
              Sign in again to continue
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={onLogout}
              disabled={isLoading}
            >
              {isLoading ? 'Signing In...' : 'Sign In Again'}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default SessionExpiredModal;